import React from "react";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <section id="hero" className="hero">
      <div className="info d-flex align-items-center">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6 text-center houser">
              <h2 data-aos="fade-down">
                Welcome to{" "}
                <span>Data Protection for Sustainable Development Goals</span>
              </h2>
              <p data-aos="fade-up" className="smallPhs">
                The objective of this website is to use data protection strategy
                to contribute to the achievement of sustainability development
                goals of the United Nations by providing collaborating platform
                and collecting data from all the stakeholders from every walk of
                life, process the data, measure the progress and also strategies
                for campaign awareness to achieve the goals.
              </p>
              <Link
                data-aos="fade-up"
                data-aos-delay="200"
                to={"/about"}
                className="btn-get-started"
              >
                Learn More
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div
        id="hero-carousel"
        className="carousel slide"
        data-bs-ride="carousel"
        data-bs-interval="5000"
      >
        <div
          className="carousel-item active"
          style={{
            backgroundImage: "url(../assets/img/asslider31.png)",
            backgroundSize: "cover",
          }}
        ></div>
        <div
          className="carousel-item"
          style={{
            backgroundImage: "url(../assets/img/asslider61.png)",
          }}
        ></div>
        <a
          className="carousel-control-prev"
          href="#hero-carousel"
          role="button"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon bi bi-chevron-left"
            aria-hidden="true"
          ></span>
        </a>

        <a
          className="carousel-control-next"
          href="#hero-carousel"
          role="button"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon bi bi-chevron-right"
            aria-hidden="true"
          ></span>
        </a>
      </div>
    </section>
  );
};

export default Header;
